var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iain-image-domain",style:({ width: _vm.width, height: _vm.height})},[(!_vm.visible)?_c('van-image',_vm._b({attrs:{"fit":"cover"}},'van-image',_vm.vanImageProps,false)):_c('van-image',_vm._b({attrs:{"fit":"cover","src":_vm.targetImagePath},on:{"click":_vm.click}},'van-image',_vm.vanImageProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }